import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M3.177 11.053 20.667 4.5l-4.383 14.432L10.969 15l-2.33 4.5-.088-6.379zM8.39 13.252l12.015-8.65M10.867 15.175l9.742-10.457"
    />
  </svg>
);
export const SendIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
